import {motion, useInView} from 'motion/react';
import {useRef, useState} from 'react';
import {Mail, MapPin, Phone, Send} from 'lucide-react';
import axios from "axios";
import {HOST} from "../constants";

export function Contact() {
    const ref = useRef(null);
    const isInView = useInView(ref, {once: true, amount: 0.3});
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        description: '',
    });

    const handleSubmit = async (e: React.FormEvent) => {
        try {
            e.preventDefault();
            setLoading(true)
            await axios.post(HOST + "/personalContact", formData)
            setLoading(false)
            alert('Thank you for your message! I will get back to you soon.');
            setFormData({name: '', phone: '', email: '', description: ''});
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    const contactInfo = [
        {
            icon: Mail,
            label: 'Email',
            value: 'zenith.takougoum@zeejaylabs.dev',
            href: 'mailto:zenith.takougoum@zeejaylabs.dev',
        },
        {
            icon: Phone,
            label: 'Phone',
            value: '+237 654 849 481',
            href: 'tel:+237654849481',
        },
        {
            icon: MapPin,
            label: 'Location',
            value: 'Bonaberi, Douala - Cameroon',
            href: null,
        },
    ];

    return (
        <section id="contact" className="py-32 px-6 bg-slate-900/50" ref={ref}>
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{opacity: 0, y: 30}}
                    animate={isInView ? {opacity: 1, y: 0} : {}}
                    transition={{duration: 0.6}}
                    className="text-center mb-16"
                >
                    <h2 className="mb-4">
                        Get In <span
                        className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Touch</span>
                    </h2>
                    <div className="w-20 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto mb-4"/>
                    <p className="text-slate-400 max-w-2xl mx-auto">
                        Have a project in mind or want to collaborate? Feel free to reach out!
                    </p>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-12">
                    {/* Contact Info */}
                    <motion.div
                        initial={{opacity: 0, x: -50}}
                        animate={isInView ? {opacity: 1, x: 0} : {}}
                        transition={{duration: 0.6, delay: 0.2}}
                        className="space-y-8"
                    >
                        <div>
                            <h3 className="text-slate-100 mb-6">Let's Connect</h3>
                            <p className="text-slate-400 mb-8">
                                I'm always interested in hearing about new projects and opportunities.
                                Whether you have a question or just want to say hi, I'll try my best
                                to get back to you!
                            </p>
                        </div>

                        <div className="space-y-6">
                            {contactInfo.map((info, index) => (
                                <motion.div
                                    key={info.label}
                                    initial={{opacity: 0, y: 20}}
                                    animate={isInView ? {opacity: 1, y: 0} : {}}
                                    transition={{duration: 0.6, delay: 0.3 + index * 0.1}}
                                    className="flex items-start gap-4"
                                >
                                    <div
                                        className="p-3 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 border border-cyan-500/30 rounded-lg">
                                        <info.icon className="text-cyan-400" size={24}/>
                                    </div>
                                    <div>
                                        <p className="text-slate-400 text-sm mb-1">{info.label}</p>
                                        {info.href ? (
                                            <a
                                                href={info.href}
                                                className="text-slate-100 hover:text-cyan-400 transition-colors"
                                            >
                                                {info.value}
                                            </a>
                                        ) : (
                                            <p className="text-slate-100">{info.value}</p>
                                        )}
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                    {/* Contact Form */}
                    <motion.div
                        initial={{opacity: 0, x: 50}}
                        animate={isInView ? {opacity: 1, x: 0} : {}}
                        transition={{duration: 0.6, delay: 0.4}}
                    >
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="name" className="block text-slate-300 mb-2">
                                    Name
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    required
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                                    className="w-full px-4 py-3 bg-slate-800/50 border border-cyan-500/20 rounded-lg text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cyan-500/50 transition-colors"
                                    placeholder="Your name"
                                />
                            </div>

                            <div>
                                <label htmlFor="name" className="block text-slate-300 mb-2">
                                    Phone
                                </label>
                                <input
                                    type="tel"
                                    id="name"
                                    value={formData.phone}
                                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                    className="w-full px-4 py-3 bg-slate-800/50 border border-cyan-500/20 rounded-lg text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cyan-500/50 transition-colors"
                                    placeholder="Your name"
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block text-slate-300 mb-2">
                                    Email
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    required
                                    value={formData.email}
                                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                                    className="w-full px-4 py-3 bg-slate-800/50 border border-cyan-500/20 rounded-lg text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cyan-500/50 transition-colors"
                                    placeholder="your.email@example.com"
                                />
                            </div>

                            <div>
                                <label htmlFor="message" className="block text-slate-300 mb-2">
                                    Message
                                </label>
                                <textarea
                                    id="message"
                                    required
                                    value={formData.description}
                                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                                    rows={5}
                                    className="w-full px-4 py-3 bg-slate-800/50 border border-cyan-500/20 rounded-lg text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cyan-500/50 transition-colors resize-none"
                                    placeholder="Your message..."
                                />
                            </div>

                            <button
                                type="submit" disabled={loading}
                                className="group w-full px-8 py-3 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all flex items-center justify-center gap-2 hover:scale-105 relative overflow-hidden"
                            >
                                <span className="relative z-10">{loading ? "Sending..." : "Send Message"}</span>
                                <Send size={18} className="relative z-10"/>
                                <div
                                    className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 opacity-0 group-hover:opacity-100 transition-opacity"/>
                            </button>
                        </form>
                    </motion.div>
                </div>

                {/* Footer */}
                <motion.div
                    initial={{opacity: 0}}
                    animate={isInView ? {opacity: 1} : {}}
                    transition={{duration: 0.6, delay: 0.6}}
                    className="mt-24 pt-8 border-t border-cyan-500/20 text-center text-slate-400"
                >
                    <p className="mb-2">© 2024 ZeeJay Labs. Built with React & Tailwind CSS.</p>
                    <p className="text-sm">Founder, CEO & Lead Developer</p>
                </motion.div>
            </div>
        </section>
    );
}